import { _Base } from "./_Base";
import { endpoints } from "./endpoints";

export class Lists extends _Base {
  endPointRoot = process.env.REACT_APP_ROOT_T_REST;

  async getLists(userId: number) {
    const url = this.endPointRoot + endpoints.lists.getByIdsFilter;
    const params = {
      searches: [
        {
          filters: [
            {
              dimension: "ownerId",
              segments: [userId],
            },
          ],
        },
      ],
    };
    const response = await this.preparePost(url, params, null);
    return response.data.ids;
  }

  async portfolioFetch(ids: number[], properties: string[]) {
    if (!properties.length) {
      return [];
    }
    const url = this.endPointRoot + endpoints.lists.fetch;
    let params = [
      {
        classType: "COLLECTION",
        id: ids,
        extendedRequest: {
          onDemandResult: properties.map((property) => ({
            dimension: property,
          })),
        },
      },
    ];
    const response = await this.preparePost(url, params, null);
    const result = response?.["data"]?.[0]?.["rows"] ?? null;
    return result;
  }

  async create(list: any, ownerId: number) {
    const url = this.endPointRoot + endpoints.lists.create;

    const params: any = {
      benchmark: list.benchmark,
      currency: list.currency??null,
      name: list.name,
      ownerId: ownerId,
      positions: [],
      type: list["type"].toUpperCase(),
      weightsDate: null,
    };

    params.positions = list.positions.map((position: any) => ({
      symbol: position.symbol,
      weight: position.weight,
    }));

    if (list?.weightsManagement?.type === "drifting") {
      params.currency = list.weightsManagement.currency;
      params.weightsDate = list.weightsManagement.date;
    }

    return this.preparePost(url, params, null);
  }

  normalize(type: any, response: any) {
    var data = [];
    var raw = null;

    switch (type) {
      case "ALL": {
        raw = response?.data?.[0]?.rows;
        for (let i = 0, length = raw.length; i < length; i++) {
          const item = raw[i];

          if (item.benchmark) {
            item.benchmark = null;
          }
        }
        data = raw;
        break;
      }
      case "GET": {
        // Get always first element, cannot have more than one anyway
        raw = response?.data?.[0]?.rows?.[0];
        if (!(raw.benchmark && raw.benchmark.symbol)) {
          raw.benchmark = null;
        }
        data = raw;
        break;
      }
    }

    return data;
  }
}
